/* eslint class-methods-use-this: 0 */

import { Node } from 'tiptap'
import BEditorExcelCell from './BEditorExcelCell.vue'


export class ExcelCell extends Node {
  get name() {
    return 'excel_cell'
  }

  get defaultOptions() {
    return {
      currentSheet: null,
      sheetTree: null,
    }
  }

  get schema() {
    return {
      group: 'inline',
      inline: true,
      content: 'text*',
      selectable: false,
      atom: true,
      attrs: {
        cell_uuid: {},
      },
      toDOM: (node) => ['excel_cell', {
        cell_uuid: node.attrs.cell_uuid,
      }],
      parseDOM: [
        {
          tag: 'excel_cell[cell_uuid]',
          getAttrs: (dom) => {
            const cell_uuid = dom.getAttribute('cell_uuid')
            return { cell_uuid }
          },
        },
      ],
    }
  }

  commands({ type }) {
    return (attrs) => (state, dispatch) => {
      const { selection } = state
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }

  get view() {
    return BEditorExcelCell
  }
}
